import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  boardWrapper: {
    overflowX: 'scroll',
    overflowY: 'auto',
    paddingBottom: theme.spacing(2),
    '&::-webkit-scrollbar': {
      width: 8,
      height: 8,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.grey[100],
      borderRadius: 4,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[400],
      borderRadius: 4,
      '&:hover': {
        backgroundColor: theme.palette.grey[600],
      },
    },
  },
  board: {
    display: 'flex',
    gap: theme.spacing(1.2),
    alignItems: 'flex-start',
    minWidth: 'max-content',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  boardSpacer: {
    minWidth: 8,
    flexShrink: 0,
  },
}))

export default useStyles
